/**
 * Labstep
 *
 * @module components/Layout/Container/Actions
 * @desc Container for actions
 */

import type React from 'react';
import styles from './styles.module.scss';
import type { LayoutContainerActionsProps } from './types';

export const LayoutContainerActions: React.FC<
  LayoutContainerActionsProps
> = ({ children }) => (
  <div className={styles.containerActions}>{children}</div>
);
